import { useState, useEffect } from "react";
import { axios } from "@root/libs/axios";
import { sendErrorLog } from "@root/shared/utils/sendErrorLog";
import { type ApiErrorResponse } from "@root/shared/types/type";
import { isApiError } from "@root/shared/utils/typeGuard";

type SuccessUserData = { phoneNumber: string } | { email: string };
type UserDataResponse = SuccessUserData | ApiErrorResponse;

type ReturnType = {
  isShowContent: boolean;
  content: string;
  isShowTelLink: boolean;
};

export const useUserData = (fetchUrl: string, isModalOpen: boolean, isSP: boolean): ReturnType => {
  const [isShowContent, setIsShowContent] = useState(false);
  const [content, setContent] = useState("");
  const [isShowTelLink, setIsShowTelLink] = useState(false);

  useEffect(() => {
    if (isModalOpen) {
      (async () => {
        try {
          const { data } = await axios.get<UserDataResponse>(fetchUrl);
          if (isApiError(data)) {
            sendErrorLog(new Error(data.message || "プロフィールの取得に失敗しました"));
            return;
          }
          if ("phoneNumber" in data) {
            setContent(data.phoneNumber);
            if (isSP) {
              setIsShowTelLink(true);
            }
          } else {
            setContent(data.email);
          }
          setIsShowContent(true);
        } catch (error) {
          sendErrorLog(
            new Error(error instanceof Error ? error.message : "プロフィールの取得に失敗しました"),
          );
        }
      })();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isModalOpen]);

  return { isShowContent, content, isShowTelLink };
};
